module.exports = {
  "country": "NL",
  "artist": "Corry Brokken",
  "song": "Net Als Toen",
  "year": "1957",
  "place": "1",
  "spotify": "1I9fugKDEYETuxJME3aesv"
};